import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3d763903")

_pushScopeId("data-v-3d763903")
const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "text-gray-lp-800 mb-2 text-12px" }, "Pastikan pesanan telah sesuai, karena pesanan tidak dapat diubah setelah diproses", -1)
const _hoisted_3 = { class: "grid grid-cols-3 pt-2 gap-2" }
const _hoisted_4 = { class: "flex flex-row items-center mt-4" }
const _hoisted_5 = { class: "p-field-checkbox mt-3" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "ml-2.5 text-12px text-left mt-2.5" }, " Saya setuju bahwa yang diproses sudah benar dan saya bertanggung jawab atas segala kesalahan ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SummaryCard = _resolveComponent("SummaryCard")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_ModalV3 = _resolveComponent("ModalV3")!

  return (_openBlock(), _createBlock(_component_ModalV3, {
    modelValue: _ctx.modelValue,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.modelValue = $event)),
    image: "badge-confirmation-general",
    imageWidth: "24",
    imageHeight: "24",
    title: "Konfirmasi proses pesanan?",
    customWidth: "740px"
  }, {
    custom: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_SummaryCard, {
            variant: "progress",
            label: "Total merchant",
            icon: "kulioner-merchant",
            completed: _ctx.totalMerchantCompleted,
            total: _ctx.totalMerchant
          }, null, 8, ["completed", "total"]),
          _createVNode(_component_SummaryCard, {
            variant: "progress",
            label: "Total produk",
            icon: "kulioner-product",
            completed: _ctx.totalProductCompleted,
            total: _ctx.totalProduct
          }, null, 8, ["completed", "total"]),
          _createVNode(_component_SummaryCard, {
            variant: "progress",
            label: "Total item",
            icon: "kulioner-item",
            completed: _ctx.totalActualPieces,
            total: _ctx.totalPieces
          }, null, 8, ["completed", "total"])
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_Checkbox, {
              id: "sender",
              modelValue: _ctx.isCheck,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.isCheck = $event)),
              binary: true
            }, null, 8, ["modelValue"])
          ]),
          _hoisted_6
        ])
      ])
    ]),
    "custom-button": _withId(() => [
      _createVNode(_component_lp_button, {
        title: "Cek Kembali",
        textColor: "red-lp-100",
        color: "red-lp-100",
        outline: "",
        onClick: _ctx.close,
        isWidthFull: ""
      }, null, 8, ["onClick"]),
      _createVNode(_component_lp_button, {
        title: "Ya, proses pesanan",
        textColor: "white",
        color: "red-lp-100",
        onClick: _ctx.confirm,
        disabled: !_ctx.isCheck,
        isWidthFull: ""
      }, null, 8, ["onClick", "disabled"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
})